import { z } from 'zod';
import { UuidSchema, IsoDateSchema, IsoDateTimeSchema } from './ids.js';
/**
 * `from`/`to` are used both as business-date range filters (dates) and as
 * instant range filters (audit events, punch history) depending on the
 * endpoint (03-API-CONTRACT.md never picks one). Accepting either an ISO
 * date or an ISO datetime keeps one shared schema usable everywhere; see the
 * README "Ambiguity resolutions".
 */
const IsoDateOrDateTimeSchema = z.union([IsoDateTimeSchema, IsoDateSchema]);
/**
 * The universal discovery params every list endpoint accepts
 * (03-API-CONTRACT.md §0, "the universal discovery" params / PRD principle).
 * `status` and `sort` are intentionally untyped strings: they are polymorphic
 * across every resource this filter is attached to (a contract's status enum
 * differs from a shift's), so per-resource endpoints narrow them further.
 */
export const DiscoveryQuerySchema = z.object({
    q: z.string().min(1).optional(),
    contractId: UuidSchema.optional(),
    siteId: UuidSchema.optional(),
    zoneId: UuidSchema.optional(),
    userId: UuidSchema.optional(),
    from: IsoDateOrDateTimeSchema.optional(),
    to: IsoDateOrDateTimeSchema.optional(),
    status: z.string().min(1).optional(),
    sort: z.string().min(1).optional(),
    order: z.enum(['asc', 'desc']).optional(),
});
//# sourceMappingURL=discovery.js.map